<!-- TODO unused since BILL-666 -->
<template>
    <form autocomplete="off" novalidate @submit.prevent="update" method="post" style="max-width: 500px">
        <q-field>
          <h-input stack-label="Полное наименование компании"
                   type="text"
                   v-model="paymentDetails.company_name"/>
        </q-field>
        <q-field>
            <q-select
                    v-model="paymentDetails.company_type"
                    :options="getCompanyType"
                    @change="update"
                    stack-label="Тип компании"
            />
        </q-field>
      <q-field>
        <h-input
            v-if="showEdrpouField"
            stack-label="ЕГРПОУ"
            type="text"
            v-model="paymentDetails.edrpou"
        />
      </q-field>
        <q-field>
          <h-input
              v-if="showInnField"
              @input="duplicateInnValue"
              :stack-label="showInnName"
              type="text"
              v-model="paymentDetails.inn"
          />
        </q-field>
        <q-field>
            <h-input stack-label="Адрес юридический"
                     type="text"
                     v-model="paymentDetails.legal_address"/>
        </q-field>
        <q-field>
            <h-input stack-label="Адрес фактический"
                     type="text"
                     v-model="paymentDetails.actual_address"/>
        </q-field>
        <q-field>
            <h-input stack-label="Должность руководителя"
                     type="text"
                     v-model="paymentDetails.user_position"/>
        </q-field>
        <q-field>
            <h-input stack-label="ФИО руководителя"
                     type="text"
                     v-model="paymentDetails.full_name"/>
        </q-field>
        <q-field>
            <h-input stack-label="IBAN"
                     type="text"
                     v-model="paymentDetails.iban"/>
        </q-field>
        <q-field>
            <h-input stack-label="Инициалы заказчика для печати"
                     type="text"
                     v-model="paymentDetails.person_initials"/>
        </q-field>
        <br>
        <q-field borderless label="Статус во Вчасно" stack-label>
            <template v-slot:control>
                <div class="self-center full-width no-outline">
                   {{paymentDetails.is_active_vchasno.valueOf()}}
                </div>
            </template>
        </q-field>
        <br>
        <div v-if="paymentDetails.is_active_vchasno" class="row justify-left q-mt-md">
                <q-btn label="Обновить" type="submit" color="primary" class="q-mr-xs"/>
                <q-btn v-on:click="turnVchasnoOff" label="Деактивировать Вчасно"
                       type="button" color="primary" class="justify-right q-mr-xs"/>
        </div>
            <div v-else class="row justify-left q-mt-md">
                <q-btn label="Обновить" type="submit" color="primary" class="q-mr-xs"/>
                <q-btn v-on:click="checkIsRegister" label="Синхронизировать с Вчасно"
                       type="button" color="primary" class="justify-right q-mr-xs"/>
            </div>
    </form>
</template>

<script>
  import columnsValues from '@/HTable/columnsValues';

  import {
    HTable,
    HTh,
    BarChart,
  } from '@';

  import HInput from '@/HInput';

  import {
    QField,
    QInput,
    QSelect,
    QChip,
    QDatetime,
    QBtn,
    QIcon,
    QCard,
    QCardTitle,
    QCardMain,
    QItem,
    QItemSide,
    QItemMain,
    QItemSeparator,
    QTable,
    QTableColumns,
    QModal,
    QTr,
    QTh,
    QTd,
    QEditor,
    date
  } from 'quasar';

  export default {
    name: "UserPaymentsData",

    components: {
      QField,
      QInput,
      QSelect,
      QChip,
      QDatetime,
      QBtn,
      QIcon,
      QModal,
      QCard,
      QCardTitle,
      QCardMain,
      QItem,
      QItemSide,
      QItemMain,
      QItemSeparator,
      QTable,
      QTableColumns,
      QTr,
      QTh,
      QTd,
      QEditor,
      date,
      HTable,
      HTh,
      HInput,
      BarChart,
    },

    props: {
      user: Object
    },

    data() {
      return {
        loading: false,
        paymentDetails: {
            company_type: [],
            company_name:'',
            inn: '',
            edrpou: '',
            legal_address: '',
            actual_address: '',
            full_name: '',
            user_position: '',
            iban: '',
            legal_person: false,
            person_initials: '',
            is_active_vchasno: false
        },
      }
    },

    computed: {
      getCompanyType () {
        return columnsValues.userType;
      },

      userCurrentCompanyType() {
        return this.paymentDetails.company_type
      },

      showInnField() {
          const companyTypesWithInn = ['0', '1', '2', '4']

        return companyTypesWithInn.includes(this.userCurrentCompanyType)
      },

      showEdrpouField() {
        return this.userCurrentCompanyType === '2' || this.userCurrentCompanyType === '3'
      },

      showInnName(){
          const companyTypesWithRnukpn = ['0', '1', '4']

         return companyTypesWithRnukpn.includes(this.userCurrentCompanyType) ? 'РНУКПН (ИНН)' : 'ИНН'
      },
    },

    methods: {
      fetchPaymentData() {
        this.$http.get(`api/v1.0/users/${this.user.id}/payments-data`)
            .then((response) => {
              this.paymentDetails = response.data;
            })
            .catch((error) => {
              if (error.response.status !== 404) {
                console.log(error.response.data);
              }
            });
      },

      update() {
        this.loading = true;

        this.$http.post(`api/v1.0/users/${this.user.id}/payments-data`, this.paymentDetails)
            .then((response) => {
              this.paymentDetails = response.data;
              this.loading = false;

              this.$q.notify({message: 'Успешно обновлено', type: 'positive'});
            })
            .catch((error) => {
              let response = error.response,
                  data = response.data;

              if (response.status === 422 && data.errors) {
                _.forIn(data.errors, (value, key) => {
                  this.$q.notify({message: value[0], type: 'negative'});
                });
              } else {
                this.$q.notify({message: 'Произошла неизвестная ошибка при сохранении', type: 'negative'});
              }

              this.loading = false;
            });
      },

      checkIsRegister() {
        this.$http.post(`api/v1.0/users/${this.user.id}/checkVchasno`, {'edrpou': this.paymentDetails.edrpou})
            .then((response) => {
              this.paymentDetails.is_active_vchasno = response.data.isRegistered;
              if (this.paymentDetails.is_active_vchasno) {
                this.$q.notify({
                  message: 'Проверенно, пользователь зарегистрирован во Вчасно',
                  type: 'positive'
                });
              } else {
                this.$q.notify({
                  message: 'Проверенно, пользователь не найден во Вчасно',
                  type: 'negative'
                });
              }
            })
            .catch((error) => {
              this.$q.notify({message: 'Произошла неизвестная ошибка при синхронизации', type: 'negative'});
            })
      },

      turnVchasnoOff() {
        this.paymentDetails.is_active_vchasno = false;
        this.update()
      },

      duplicateInnValue(value) {
        if (this.showEdrpouField) {
          return
        }

        this.paymentDetails.edrpou = value
      }
    },

    created () {
      this.fetchPaymentData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPaymentsData/UserPaymentsData.vue